import { render, staticRenderFns } from "./CardNewLockerManager.vue?vue&type=template&id=36b65b2c&"
import script from "./CardNewLockerManager.vue?vue&type=script&lang=js&"
export * from "./CardNewLockerManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports